// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jEE1","requiredAsterisk":"Info_requiredAsterisk__1snc2"};